import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import ptBR from './locales/pt-BR.json';
import enUS from './locales/en-US.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      'pt-BR': { translation: ptBR },
      'en-US': { translation: enUS }
    },
    fallbackLng: 'pt-BR',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      // Normalize language codes - remove @posix, @euro and other suffixes
      convertDetectedLanguage: (lng) => {
        // Remove suffixes like @posix, @euro, etc.
        const normalized = lng.split('@')[0];
        // Map common variations to our supported languages
        if (normalized.startsWith('en')) return 'en-US';
        if (normalized.startsWith('pt')) return 'pt-BR';
        return normalized;
      }
    }
  });

export default i18n;
